import { makeStyles } from "@material-ui/core";

const useRbRadioStyles = makeStyles(() => ({
  root: {
    width: 32,
    height: 32,
    padding: 0,
  },
}));

export default useRbRadioStyles;
